import actionTypes from './actionTypes';

const INITIAL_STATE = {
  printersList: [],
  printersTotalPage: {},
  getAllPrintersListLoading: false,
  getAllPrintersListReject: false,
  getAllPrintersListFailed: false,
  getAllPrintersListMessage: null,

  printerDetails: [],
  getPrinterByIdLoading: false,
  getPrinterByIdReject: false,
  getPrinterByIdFailed: false,
  getPrinterByIdMessage: null,

  updatePrinterLoading: false,
  updatePrinterReject: false,
  updatePrinterFailed: false,
  updatePrinterMessage: null,

  updateActivePrinterLoading: false,
  updateActivePrinterReject: false,
  updateActivePrinterFailed: false,
  updateActivePrinterMessage: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_PRINTERS_LIST_LOADING: {
      return {
        ...state,
        getAllPrintersListLoading: true,
        getAllPrintersListReject: false,
        getAllPrintersListFailed: false,
        getAllPrintersListMessage: null,
        printersList: [],
        printersTotalPage: {},
      };
    }
    case actionTypes.GET_ALL_PRINTERS_LIST_SUCCESS: {
      return {
        ...state,
        getAllPrintersListLoading: false,
        getAllPrintersListReject: false,
        getAllPrintersListFailed: false,
        getAllPrintersListMessage: null,
        printersList: [...action.payload.printers],
        printersTotalPage: { ...action.payload },
      };
    }
    case actionTypes.UPDATE_ACTIVE_PRINTER_SUCCESS: {
      return {
        ...state,
        printersList: action.payload,
      };
    }
    case actionTypes.GET_ALL_PRINTERS_LIST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getAllPrintersListLoading: false,
        getAllPrintersListReject: false,
        getAllPrintersListFailed: true,
        getAllPrintersListMessage: message,
        printersList: [],
        printersTotalPage: {},
      };
    }
    case actionTypes.GET_ALL_PRINTERS_LIST_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getAllPrintersListLoading: false,
        getAllPrintersListReject: true,
        getAllPrintersListFailed: false,
        getAllPrintersListMessage: message,
        printersList: [],
        printersTotalPage: {},
      };
    }
    case actionTypes.GET_PRINTER_BY_ID_LOADING: {
      return {
        ...state,
        printerDetails: [],
        getPrinterByIdLoading: true,
        getPrinterByIdReject: false,
        getPrinterByIdFailed: false,
        getPrinterByIdMessage: null,
      };
    }
    case actionTypes.GET_PRINTER_BY_ID_SUCCESS: {
      return {
        ...state,
        printerDetails: [...action.payload],
        getPrinterByIdLoading: false,
        getPrinterByIdReject: false,
        getPrinterByIdFailed: false,
        getPrinterByIdMessage: null,
      };
    }
    case actionTypes.GET_PRINTER_BY_ID_REJECT: {
      return {
        ...state,
        printerDetails: [],
        getPrinterByIdLoading: false,
        getPrinterByIdReject: true,
        getPrinterByIdFailed: false,
        getPrinterByIdMessage: null,
      };
    }
    case actionTypes.GET_PRINTER_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        printerDetails: [],
        getPrinterByIdLoading: false,
        getPrinterByIdReject: false,
        getPrinterByIdFailed: true,
        getPrinterByIdMessage: message,
      };
    }
    case actionTypes.UPDATE_PRINTER_LOADING: {
      return {
        ...state,
        updatePrinterLoading: true,
        updatePrinterReject: false,
        updatePrinterFailed: false,
        updatePrinterMessage: null,
      };
    }
    case actionTypes.UPDATE_PRINTER_SUCCESS: {
      return {
        ...state,
        updatePrinterLoading: false,
        updatePrinterReject: false,
        updatePrinterFailed: false,
        updatePrinterMessage: null,
        printersList: action.payload,
      };
    }
    case actionTypes.UPDATE_PRINTER_REJECT: {
      return {
        ...state,
        updatePrinterLoading: false,
        updatePrinterReject: true,
        updatePrinterFailed: false,
        updatePrinterMessage: null,
      };
    }
    case actionTypes.UPDATE_PRINTER_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updatePrinterLoading: false,
        updatePrinterReject: false,
        updatePrinterFailed: true,
        updatePrinterMessage: message,
      };
    }

    default:
      return state;
  }
};
